import type { EventType } from 'models';
import {
  CommentsWrapperSocialEventContent,
  type CommentsWrapperSocialEventContentProperties,
} from './comments-wrapper-social-event-content';

type P = {
  eventType: EventType;
} & CommentsWrapperSocialEventContentProperties;

const CommentsWrapperSocialEvent = ({ eventType, ...props }: P) => {
  if (eventType === 'telehealth_visit' || eventType === 'reminder') {
    return null;
  }

  return <CommentsWrapperSocialEventContent {...props} />;
};

export default CommentsWrapperSocialEvent;
